import React, { Component } from 'react';
// import FetchCall from '../../API/FetchCall';
import { getInvoiceInfo } from '../../../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';
import SchoolCompare from './school_compare';
import PreSchoolCompare from './preschool_compare';
import HobbiesCompare from './hobbies_compare';
import LearningCompare from './learning_compare';
import TuitionCompare from './tuition_compare';
import EventCompare from './events_compare';
import PlayAreaCompare from './playarea_compare';
import ComSprtCompare from './community_support_compare';

//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723

//npm i @progress/kendo-drawing

class CompareView extends Component {

  constructor(props) {
    super(props);
    let cdata = localStorage.getItem('compare_data');
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = dd + '-' + mm + '-' + yyyy;
    if (!cdata) {
      window.location.href = '/partner/bench_mark';
    } else {
      cdata = JSON.parse(cdata);
    }
    console.log('cdata', cdata);
    this.state = {
      compareData: cdata ? (cdata.data) : [],
      ratingData: cdata ? (cdata.rating) : [],
      compareType: cdata ? cdata.type : 0,
      orders: [],
      date: today
    };
  }
  componentDidMount() {

  }
  createPdf = (html) => Doc.createPdf(html);


  render() {
    const view_data = {
      compareData: this.state.compareData,
      ratingData: this.state.ratingData,
      date: this.state.date,
      compareType: this.state.compareType
    }
    console.log('view_data', view_data)
    return (

      <React.Fragment>
        <div className="box-shadow-custom">
          <PdfContainer createPdf={this.createPdf}>
            {this.state.compareType == 1 && <SchoolCompare viewData={view_data} />}
            {this.state.compareType == 2 && <PreSchoolCompare viewData={view_data} />}
            {this.state.compareType == 3 && <PlayAreaCompare viewData={view_data} />}
            {this.state.compareType == 4 && <HobbiesCompare viewData={view_data} />}
            {this.state.compareType == 8 && <LearningCompare viewData={view_data} />}
            {this.state.compareType == 6 && <TuitionCompare viewData={view_data} />}
            {this.state.compareType == 7 && <EventCompare viewData={view_data} />}
            {this.state.compareType == 121 && <ComSprtCompare viewData={view_data} />}
          </PdfContainer>
        </div>
      </React.Fragment>

    );
  }
}

export default CompareView;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/compare.jsx